import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';

import { styled } from '@mui/material/styles';

export const TabsRootWrapper = styled(Box, {
  shouldForwardProp: (propName) => !['isCollapsed', 'orientation'].includes(propName),
  label: 'TabsRootWrapper',
})(({ theme, orientation, isCollapsed }) => {
  return {
    position: 'relative',
    marginRight: orientation === 'vertical' ? theme.spacing(3) : 0,

    '& > .MuiButtonBase-root': {
      display: isCollapsed ? 'inline-flex' : 'none',
    },

    '&:hover': {
      '& > .MuiButtonBase-root': {
        display: 'inline-flex',
      },
    },
  };
});

export const StyledPaper = styled(Paper)(({ theme }) => ({
  width: 270,
  border: `1px solid ${theme.palette.grey[200]}`,
  padding: theme.spacing(3, 0),
  paddingRight: 0,
  position: 'relative',
}));

export const CollapseButton = styled(IconButton, { label: 'CollapseButton' })(({ theme }) => ({
  top: 0,
  width: 40,
  height: 40,
  right: -20,
  boxShadow: '0px 1px 18px 0px #0000001F, 0px 6px 10px 0px #00000024, 0px 3px 5px -1px #00000033',
  backgroundColor: theme.palette.common.white,

  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}));
